import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ReferralsApi - axios parameter creator
 * @export
 */
const ReferralsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Admin: a customer\'s referral code, who referred them, and the customers who joined with their codes. (Auth roles: Customers)
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReferrals: async (customerId, options = {}) => {
            const localVarPath = `/v1/Referrals/GetCustomerReferrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary The caller\'s referral code (created on the first visit), what a referral earns, and who joined with it. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMine: async (options = {}) => {
            const localVarPath = `/v1/Referrals/GetMine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Admin: gives the customer a new referral code and expires the old one, so links already sent with it stop applying. (Auth roles: Customers)
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateCode: async (customerId, options = {}) => {
            const localVarPath = `/v1/Referrals/RegenerateCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ReferralsApi - functional programming interface
 * @export
 */
const ReferralsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReferralsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Admin: a customer\'s referral code, who referred them, and the customers who joined with their codes. (Auth roles: Customers)
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerReferrals(customerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerReferrals(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralsApi.getCustomerReferrals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary The caller\'s referral code (created on the first visit), what a referral earns, and who joined with it. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMine(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMine(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralsApi.getMine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Admin: gives the customer a new referral code and expires the old one, so links already sent with it stop applying. (Auth roles: Customers)
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regenerateCode(customerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regenerateCode(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralsApi.regenerateCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ReferralsApi - factory interface
 * @export
 */
const ReferralsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReferralsApiFp(configuration);
    return {
        /**
         *
         * @summary Admin: a customer\'s referral code, who referred them, and the customers who joined with their codes. (Auth roles: Customers)
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReferrals(customerId, options) {
            return localVarFp.getCustomerReferrals(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary The caller\'s referral code (created on the first visit), what a referral earns, and who joined with it. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMine(options) {
            return localVarFp.getMine(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Admin: gives the customer a new referral code and expires the old one, so links already sent with it stop applying. (Auth roles: Customers)
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateCode(customerId, options) {
            return localVarFp.regenerateCode(customerId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReferralsApi - object-oriented interface
 * @export
 * @class ReferralsApi
 * @extends {BaseAPI}
 */
class ReferralsApi extends BaseAPI {
    /**
     *
     * @summary Admin: a customer\'s referral code, who referred them, and the customers who joined with their codes. (Auth roles: Customers)
     * @param {number} [customerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApi
     */
    getCustomerReferrals(customerId, options) {
        return ReferralsApiFp(this.configuration).getCustomerReferrals(customerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary The caller\'s referral code (created on the first visit), what a referral earns, and who joined with it. (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApi
     */
    getMine(options) {
        return ReferralsApiFp(this.configuration).getMine(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Admin: gives the customer a new referral code and expires the old one, so links already sent with it stop applying. (Auth roles: Customers)
     * @param {number} [customerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApi
     */
    regenerateCode(customerId, options) {
        return ReferralsApiFp(this.configuration).regenerateCode(customerId, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ReferralsApi, ReferralsApiAxiosParamCreator, ReferralsApiFactory, ReferralsApiFp };
//# sourceMappingURL=referrals-api.js.map
